<div class="row">
  <div class="col-lg-6">
    <div class="container-fluid pl-0 info-list has-info-icon">
      <app-pie-chart [data]="pieChartData"></app-pie-chart>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="container-fluid pr-0 info-list">
      <h3 class="sub-title">
        Platform Distribution <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon">
      </h3>
      <ng-container *ngFor="let platform of data?.platformDistribution; let i = index;">
        <div class="d-flex info-list-item">
          <div class="label">
            {{platform?.deviceMarketingName}}
          </div>
          <div class="value text-capitalize">
            {{platform?.totalTrafficRatio | perc: '1.2-2'}}
          </div>
        </div>
        <div class="divider" *ngIf="i < data?.platformDistribution?.length - 1"></div>
      </ng-container>

    </div>
  </div>
</div>
